import React from 'react';

import {
  Table,
  createColumnWidths,
  createColumnsWidths,
} from '@qality/common-components/src/atoms/Table';
import { FieldSpan } from '@qality/common-components/src/molecules/final-form/FieldSpan';
import { Select } from '@qality/common-components/src/molecules/final-form/Select';
import { StorageOfUniqueServices } from '@qality/common-service';

import {
  FieldSelectWrapperStyled,
  FieldSpanWrapperStyled,
} from './AttributeMapperField.styled';

type Columns = 'csv' | 'arrow' | 'field';

const ColumnsWidths = createColumnsWidths<Columns>({
  csv: createColumnWidths('180px', '120px'),
  arrow: createColumnWidths('80px'),
  field: createColumnWidths('auto', '240px'),
});

type Props = {
  fields: any;
  options: any;
};

export default function AttributeMapperFieldView({
  fields,
  options,
}: Props): JSX.Element {
  const ArrowWithShadowSVG =
    StorageOfUniqueServices.get('URLService').getArrowWithShadowIcon();

  return (
    <Table addLinesBetweenRows data-testid='AttributeMapperFieldView-Table'>
      <Table.Head>
        <Table.Tr>
          <Table.Th widths={ColumnsWidths.csv}>CSV field</Table.Th>
          <Table.Th widths={ColumnsWidths.arrow} />
          <Table.Th widths={ColumnsWidths.field}>Jira issue field</Table.Th>
        </Table.Tr>
      </Table.Head>

      <Table.Body>
        {fields.map((name, index) => (
          <Table.Tr
            data-testid='AttributeMapperFieldView-Tr'
            key={name + index}
          >
            <Table.Td>
              <Table.ContentHelper alignItems='center'>
                <FieldSpanWrapperStyled>
                  <FieldSpan name={`${name}.from`} />
                </FieldSpanWrapperStyled>
              </Table.ContentHelper>
            </Table.Td>
            <Table.Td>
              <Table.ContentHelper height='full' alignItems='center'>
                <img alt='Arrow right icon' src={ArrowWithShadowSVG} />
              </Table.ContentHelper>
            </Table.Td>
            <Table.Td>
              <Table.ContentHelper height='full' alignItems='center'>
                <FieldSelectWrapperStyled>
                  <Select
                    size='small'
                    isClearable
                    name={`${name}.to`}
                    options={options}
                    placeholder='Choose something'
                  />
                </FieldSelectWrapperStyled>
              </Table.ContentHelper>
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Body>
    </Table>
  );
}
